// src/components/UserCard.jsx
import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import UserProfileImage from "@/shared-components/cards/components/UserProfileImage";
import Text from "@/shared-components/text/components/Text";

import "./styles/UserSliderCard.css";

export default function UserCard({ user, onVisit }) {
  const imageId = user.profilePic || null;

  return (
    <div className="user-card__container">
      <div className="user-card__image-wrapper">
        <UserProfileImage
          image={imageId}
          typeOfProfile="user"
          className="user-card__avatar"
        />
      </div>
      <div className="user-card__info">
        <Text className="user-card__name font-size-medium">
          {user.username}
        </Text>
        <ContinueButton
          className="user-card__button"
          onClick={onVisit}
        >
          Visit profile
        </ContinueButton>
      </div>
    </div>
  );
}
